<script setup lang="ts">
import type { TooltipTriggerProps } from "reka-ui"
import { injectTooltipRootContext, TooltipTrigger } from "reka-ui"
import { nextTick } from "vue"

const props = defineProps<TooltipTriggerProps>()
const tooltip = injectTooltipRootContext()
let touchShouldOpen: boolean | undefined

function onPointerDown(event: PointerEvent) {
  // Capture before Reka closes an open tooltip on pointerdown.
  touchShouldOpen = event.pointerType === 'touch' && !tooltip.disabled.value
    ? !tooltip.open.value
    : undefined
}

function clearTouch() {
  touchShouldOpen = undefined
}

async function onClick(event: MouseEvent) {
  const shouldOpen = touchShouldOpen
  clearTouch()
  if (shouldOpen === undefined || event.detail === 0) return

  // Reka's click handler closes tooltips. Apply the touch toggle after that
  // handler and the child's own action, without cancelling either click.
  await nextTick()
  if (tooltip.disabled.value || !tooltip.trigger.value?.isConnected) return
  if (shouldOpen) tooltip.onOpen()
  else tooltip.onClose()
}
</script>

<template>
  <TooltipTrigger
    v-bind="props"
    @pointerdown.capture="onPointerDown"
    @pointercancel="clearTouch"
    @click="onClick"
  >
    <slot />
  </TooltipTrigger>
</template>
